import React from "react";

interface AddToCartButtonProps {
  onAddToCart: () => void;
  disabled?: boolean;
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  onAddToCart,
  disabled = false,
}) => {
  return (
    <button
      className="add-to-cart-btn"
      onClick={onAddToCart}
      disabled={disabled}
    >
      Donate
    </button>
  );
};

export default AddToCartButton;
